






































import Vue from "vue";
import {Component} from "vue-property-decorator";

interface ChageLogItem {
  version: string;
  when: string;
  operation: string;
  description: string;
}

@Component
export default class ChangeLogList extends Vue {
  items: ChageLogItem[] = [
    {
      version: "1.0.0",
      when: "2021-04-07",
      operation: "add",
      description: "initial system published "
    }
  ];
  search = "";

  pagination: any = {
    descending: true,
    page: 1,
    rowsPerPage: -1, // -1 for All",
    sortBy: "when",
    totalItems: this.items!.length
  };
  headers: any[] = [
    {
      text: "When",
      value: "when",
      align: "left"
    },
    {
      text: "Operation",
      value: "operation",
      align: "left"
    },
    {
      text: "Description",
      value: "description",
      align: "left"
    }
  ];
}
